import * as React from 'react'

import { Space, Typography } from '../../atoms'
import { Variant } from '../../atoms/typography/typography'

export interface IconLabelProps {
  icon: React.ReactNode
  iconPosition: 'left' | 'right'
  text: string
  variant?: Variant
}

const IconLabel = ({ icon, iconPosition, text, variant }: IconLabelProps) => {
  const labelVariant = variant ?? 'b3'
  return (
    <Typography variant={labelVariant}>
      <Space isflex alignContent="center" alignItems="center" margin="auto">
        {iconPosition && iconPosition === 'left' && icon}
        <Space mx={2}>{text}</Space>
        {iconPosition && iconPosition === 'right' && icon}
      </Space>
    </Typography>
  )
}

export default IconLabel
